var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconGitHubSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 .187a8 8 0 0 0-2.48 15.606h.187a.67.67 0 0 0 .647-.406.7.7 0 0 0 .06-.3v-.867a.33.33 0 0 0-.127-.22.33.33 0 0 0-.274-.067c-1.793.387-2.173-.733-2.193-.806a3.1 3.1 0 0 0-1.153-1.46l-.1-.074a.5.5 0 0 1 .253-.046.99.99 0 0 1 .76.586 2 2 0 0 0 2.667.774.35.35 0 0 0 .2-.24c.027-.306.159-.594.373-.814a.33.33 0 0 0 .1-.353.33.33 0 0 0-.28-.233c-1.58-.18-3.2-.734-3.2-3.46a2.67 2.67 0 0 1 .707-1.854.33.33 0 0 0 .06-.346A2.37 2.37 0 0 1 4.213 4c.616.11 1.194.374 1.68.767a.32.32 0 0 0 .28.04 7.1 7.1 0 0 1 3.66 0 .3.3 0 0 0 .274-.04A3.7 3.7 0 0 1 11.787 4a2.36 2.36 0 0 1 0 1.587.32.32 0 0 0 .066.346c.458.5.709 1.156.7 1.834 0 2.733-1.62 3.28-3.206 3.453a.33.33 0 0 0-.28.233.33.33 0 0 0 .1.347 1.49 1.49 0 0 1 .406 1.167v2.12a.7.7 0 0 0 .247.546.79.79 0 0 0 .707.127A8 8 0 0 0 8 .187"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 .187a8 8 0 0 0-2.48 15.606h.187a.67.67 0 0 0 .647-.406.7.7 0 0 0 .06-.3v-.867a.33.33 0 0 0-.127-.22.33.33 0 0 0-.274-.067c-1.793.387-2.173-.733-2.193-.806a3.1 3.1 0 0 0-1.153-1.46l-.1-.074a.5.5 0 0 1 .253-.046.99.99 0 0 1 .76.586 2 2 0 0 0 2.667.774.35.35 0 0 0 .2-.24c.027-.306.159-.594.373-.814a.33.33 0 0 0 .1-.353.33.33 0 0 0-.28-.233c-1.58-.18-3.2-.734-3.2-3.46a2.67 2.67 0 0 1 .707-1.854.33.33 0 0 0 .06-.346A2.37 2.37 0 0 1 4.213 4c.616.11 1.194.374 1.68.767a.32.32 0 0 0 .28.04 7.1 7.1 0 0 1 3.66 0 .3.3 0 0 0 .274-.04A3.7 3.7 0 0 1 11.787 4a2.36 2.36 0 0 1 0 1.587.32.32 0 0 0 .066.346c.458.5.709 1.156.7 1.834 0 2.733-1.62 3.28-3.206 3.453a.33.33 0 0 0-.28.233.33.33 0 0 0 .1.347 1.49 1.49 0 0 1 .406 1.167v2.12a.7.7 0 0 0 .247.546.79.79 0 0 0 .707.127A8 8 0 0 0 8 .187"
  })));
});
export default SvgIconGitHubSolid;
export const raw = __webpack_public_path__ + "static/media/IconGitHubSolid.7bf0bd27f33b737ea1059ce9cfb8406b.svg";